/**
 * Starting a file download from the console.
 *
 * Every download here happens *after* awaiting a grant mint, which puts the call outside
 * the user-gesture stack — and Chrome blocks a programmatic `window.open` there. That is
 * why the console could say "link minted" while no file ever arrived: the popup was
 * blocked, and the toast's own fallback text ("your browser blocked the new tab") was the
 * only sign. An anchor click carries no such restriction.
 *
 * Nothing navigates away, because the resolver answers `/d/{token}` with a 302 to a
 * presigned URL carrying `Content-Disposition: attachment` (services/resolver/presign.py).
 * A browser handed an attachment keeps the page it is on.
 */

/**
 * Download `url`, which must be answered with an attachment disposition.
 *
 * `filename` is set even though a cross-origin response ignores it — the API and the
 * console are different origins today. Where it is ignored the attachment header names the
 * file anyway; where it is honoured it is the better name.
 */
export function startDownload(url: string, filename?: string): void {
  const anchor = document.createElement('a');
  anchor.href = url;
  if (filename) anchor.download = filename;
  anchor.rel = 'noopener';
  anchor.style.display = 'none';
  // Firefox requires the element to be in the document for a synthetic click to count.
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}
